import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useLang, EASE } from "@/lib/site";
import { copy, quotes } from "@/lib/content";
import { ShareButton } from "./Quotes";

const todayIndex = () => {
  const d = new Date();
  const days = Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
  return days % quotes.length;
};

export const DailyQuote = () => {
  const { lang } = useLang();
  const t = copy[lang];
  const i = todayIndex();
  const q = quotes[i];
  const date = new Date().toLocaleDateString(lang === "id" ? "id-ID" : "en-US", { weekday: "long", day: "numeric", month: "long" });
  return (
    <motion.figure data-testid="daily-quote" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 1.05, ease: EASE }}
      className="relative mt-12 max-w-xl overflow-hidden rounded-2xl border border-amber-200/15 bg-[#0D1322]/70 backdrop-blur-md p-5 sm:p-6">
      <span className="absolute inset-y-0 left-0 w-[3px] bg-gradient-to-b from-amber-200 via-amber-400 to-amber-700" />
      <div className="flex flex-wrap items-center justify-between gap-2 font-mono text-[11px] uppercase tracking-[0.22em]">
        <span className="flex items-center gap-2 text-amber-300"><Sparkles size={14} />{t.dailyLabel}</span>
        <span data-testid="daily-quote-date" className="text-slate-400">{date}</span>
      </div>
      <blockquote data-testid="daily-quote-text" className="font-display mt-4 text-xl sm:text-[1.4rem] italic leading-snug text-slate-100">“{q[lang]}”</blockquote>
      <figcaption className="mt-4 flex items-center justify-between gap-4">
        <span className="text-xs text-slate-400">{t.dailyHint}</span>
        <ShareButton q={q} n={i + 1} lang={lang} testId="daily-quote-download-button" />
      </figcaption>
    </motion.figure>
  );
};
